export enum EditorView {
    Data = 'data',
    Metrics = 'metrics',
    Buildings = 'buildings',
    Costs = 'costs',
    Energy = 'energy',
    Media = 'media',
}
